import { render, staticRenderFns } from "./org-tree.vue?vue&type=template&id=c672d4a2&"
import script from "./org-tree.vue?vue&type=script&lang=js&"
export * from "./org-tree.vue?vue&type=script&lang=js&"
import style0 from "./org-tree.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\bin-tree-org\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c672d4a2')) {
      api.createRecord('c672d4a2', component.options)
    } else {
      api.reload('c672d4a2', component.options)
    }
    module.hot.accept("./org-tree.vue?vue&type=template&id=c672d4a2&", function () {
      api.rerender('c672d4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/org-tree/org-tree.vue"
export default component.exports